import { takeEvery, put, call, select, race } from "redux-saga/effects"
// Utils
import request from "Utils/request"
import { config } from "Utils/config"
import { getCors, postCors, patchCors, deleteCors } from "Utils/rulesCors"
import { getRelatedFiles } from "ContainersForm/ETL/utils.js"
//constants
import {
  GET_ACTUALITY,
  GET_ACTUALITY_BY_ID,
  POST_ACTUALITY,
  POST_FILE_ACTUALITY,
  PATCH_ACTUALITY,
  ARCHIVED_ACTUALITY,
  DELETE_ACTUALITY,
  GET_GOVERNANCE,
  GET_GOVERNANCE_BY_ID,
  POST_GOVERNANCE,
  PATCH_GOVERNANCE,
  DELETE_GOVERNANCE,
  GET_DOCUMENT_SOLLICITE,
  GET_DOCUMENTS_WAIT_VALIDATION,
  GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS,
  GET_DOCUMENTS_BY_CONTROL_ID,
  PATCH_DOCUMENT_SOLLICITE,
  DELETE_DOCUMENT_SOLLICITE,
  CONFIRM_DOCUMENTS_ADDED_BY_CLIENT,
  VALIDATE_DOCUMENT_SOLLICITE,
  REJECT_DOCUMENT_SOLLICITE,
  GET_DOCUMENTS_ASSOCIATE_RESPONSE,
  POST_DOCUMENTS_ASSOCIATE_RESPONSE,
  POST_DOCUMENT_ASSOCIATE_RESPONSE_MAPPING_RISK,
  POST_DOCUMENT_ASSOCIATE_RESPONSE_MAPPING_RISK_V2,
  DELETE_DOCUMENT_ASSOCIATE_BY_ID,
} from "./constants"
// Actions
import {
  setSuccessMessage,
  setErrorMessage,
  removeErrorMessage,
  removeSuccessMessage,
} from "Containers/Messages/actions"
import { getControlAndTemplateByIdAction } from "ContainersForm/ControlPlans/actions.js"

import {
  getActualityAction,
  getActualitySuccess,
  getActualityByIdSuccess,
  getGovernanceAction,
  getGovernanceSuccess,
  getGovernanceByIdSuccess,
  getDocumentsSuccessAction,
  getDocumentsWaitValidationAction,
  getDocumentsWaitValidationSuccessAction,
  getDocumentsByControlIdSuccessAction,
  getControlPlanWithControlsArchivedSuccessAction,
  getDocumentsAssociateResponseAction,
  getDocumentsAssociateResponseSuccessAction,
  postFilesActualitySuccessAction,
} from "./actions"

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  manageErrorGenerator,
  manageSuccessGenerator,
} from "Containers/App/saga"
import { postFileToS3 } from "ContainersForm/ETL/saga.js"
// Selectors
import { selectCurrentToken } from "Containers/Login/selectors.js"
// Sagas
import { manageFilesETLsaga } from "ContainersForm/ETL/saga"
//**********************************************************************************************
//************************************* SAGA Actualité *****************************************
//**********************************************************************************************
//GET_ACTUALITY
function* getAllActualitySaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/actualityAndRegulatory`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getActualitySuccess(response))
      }
    }
  } catch (err) {
    console.error("[route] => /actualityAndRegulatory => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* getActualityByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { actualityId } = payload
  const requestURL = `${FORM_BACK_URL}/actualityAndRegulatory/${actualityId}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getActualitySuccess(response))
      }
    }
  } catch (err) {
    console.error("[route] => /actualityAndRegulatory/:actualityId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//POST_ACTUALITY
function* postActualitySaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { newActuality, filesActuality } = payload
  const requestURL = `${FORM_BACK_URL}/actualityAndRegulatory`
  let documentsActuality = []

  try {
    // 1) we loop over the files to add them to the ETL
    for (let file of filesActuality) {
      const responsePostFile = yield call(postFileToS3, file)
      if (responseTypeIsError(responsePostFile)) {
        yield call(manageErrorGenerator, { response: responsePostFile, showMessageToUser: true })
      } else {
        const fileName = responsePostFile?.body?.name
        const newFilePosted = {
          name: responsePostFile?.body?.name,
          uuid: responsePostFile?.body?.uuid,
        }
        documentsActuality.push(newFilePosted)
      }
    }
    // 2) we compare length of files and ETLFiles and if its equal we save fileNames in back
    if (filesActuality.length === documentsActuality.length) {
      const actualityPost = {
        ...newActuality,
        filesAttachedIds: documentsActuality,
      }
      const response = yield call(request, requestURL, postCors(actualityPost, specificHeaders))
      if (responseTypeIsError(response))
        yield call(manageErrorGenerator, { response, showMessageToUser: true })
      else {
        if (responseTypeIsSuccess(response)) {
          yield call(manageSuccessGenerator, { response, showMessageToUser: true })
          yield put(getActualityAction())
        }
      }
    }
  } catch (err) {
    console.error("[route] => /actualityAndRegulatory => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//PATCH_ACTUALITY
function* patchActualitySaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { actualityId, updateActuality, filesActualityToUpdate, filesActualityToDelete } = payload
  const requestURL = `${FORM_BACK_URL}/actualityAndRegulatory/${actualityId}`
  let documentsActuality = []

  try {
    // 1) we loop over the files to add them to the ETL
    for (let file of filesActualityToUpdate) {
      const responsePostFile = yield call(postFileToS3, file)
      if (responseTypeIsError(responsePostFile)) {
        yield call(manageErrorGenerator, { response: responsePostFile, showMessageToUser: true })
      } else {
        const fileName = responsePostFile?.body?.name
        const newFilePosted = {
          name: responsePostFile?.body?.name,
          uuid: responsePostFile?.body?.uuid,
        }
        documentsActuality.push(newFilePosted)
      }
    }
    console.log("documentsActuality", documentsActuality)
    // 2) we compare length of files and ETLFiles and if its equal we save fileNames in back
    if (filesActualityToUpdate.length === documentsActuality.length) {
      const filesAttached = updateActuality?.filesAttachedIds.concat(documentsActuality)
      const actualityPatch = {
        ...updateActuality,
        filesAttachedIds: filesAttached,
      }
      console.log("actualityPatch", actualityPatch)
      const response = yield call(
        request,
        requestURL,
        patchCors({ actualityPatch, typeSave: "update" }, specificHeaders)
      )
      if (responseTypeIsError(response)) {
        yield call(manageErrorGenerator, { response, showMessageToUser: true })
      } else {
        if (responseTypeIsSuccess(response)) {
          yield call(manageSuccessGenerator, { response, showMessageToUser: true })
          yield put(getActualityAction())
        }
      }
    }
  } catch (err) {
    console.error("[route] => /actualityAndRegulatory => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//ARCHIVED_ACTUALITY
function* patchArchivedActualitySaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { actualityId } = payload
  const requestURL = `${FORM_BACK_URL}/actualityAndRegulatory/${actualityId}`
  const actualityPatch = {
    _id: { $oid: actualityId },
    isArchived: true,
  }

  try {
    const response = yield call(
      request,
      requestURL,
      patchCors({ actualityPatch, typeSave: "archived" }, specificHeaders)
    )
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getActualityAction())
      }
    }
  } catch (err) {
    console.error("[route] => /actualityAndRegulatory ARCHIVED=> ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//DELETE_ACTUALITY
function* deleteActualitySaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { actualityId } = payload
  const requestURL = `${FORM_BACK_URL}/actualityAndRegulatory/${actualityId}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getActualityAction())
      }
    }
  } catch (err) {
    console.error("[route] => /actualityAndRegulatory => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//POST_FILE_ACTUALITY
function* postFilesActualitySaga({ payload }) {
  const newFile = payload?.file
  console.log("newFile", newFile)
  try {
    const response = yield call(postFileToS3, newFile)
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      const newFilePosted = {
        name: response?.body?.name,
        uuid: response?.body?.uuid,
      }
      console.log("newFilePosted", newFilePosted)
      yield put(postFilesActualitySuccessAction(newFilePosted))
    }
  } catch (err) {
    console.error(`[route] => ERROR POST PIECES JOINTES ACTUALITY => `, err)
    yield put(setErrorMessage(err))
  }
}

//**********************************************************************************************
//*********************************** SAGA Gouvernance *****************************************
//**********************************************************************************************
//GET_GOVERNANCE
function* getAllGovernanceSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/governance`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getGovernanceSuccess(response))
      }
    }
  } catch (err) {
    console.error("[route] => /governance => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//GET_GOVERNANCE_BY_ID
function* getGovernanceByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { governanceId } = payload
  const requestURL = `${FORM_BACK_URL}/governance/${governanceId}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getGovernanceSuccess(response))
      }
    }
  } catch (err) {
    console.error("[route] => /governance/:governanceId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//POST_GOVERNANCE
function* postGovernanceSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { newGovernance, filesToManage } = payload
  const requestURL = `${FORM_BACK_URL}/governance`

  try {
    if (filesToManage) {
      const previousGovernanceFiles = []
      const manageFilesResponse = yield call(manageFilesETLsaga, filesToManage)
      const { uploadedFiles, removedFiles } = manageFilesResponse
      newGovernance["relatedFiles"] = getRelatedFiles(
        previousGovernanceFiles,
        uploadedFiles,
        removedFiles
      )
    }

    const response = yield call(request, requestURL, postCors(newGovernance, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getGovernanceAction())
      }
    }
  } catch (err) {
    console.error("[route] => /governance => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//PATCH_GOVERNANCE
function* patchGovernanceSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { governanceId, updateGovernance, filesToManage } = payload
  const requestURL = `${FORM_BACK_URL}/governance/${governanceId}`

  try {
    if (filesToManage) {
      const previousNonConformityFiles = updateGovernance?.relatedFiles
      const manageFilesResponse = yield call(manageFilesETLsaga, filesToManage)
      const { uploadedFiles, removedFiles } = manageFilesResponse
      updateGovernance["relatedFiles"] = getRelatedFiles(
        previousNonConformityFiles,
        uploadedFiles,
        removedFiles
      )
    }
    const response = yield call(request, requestURL, patchCors(updateGovernance, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getGovernanceAction())
      }
    }
  } catch (err) {
    console.error("[route] => /governance/:governanceId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//DELETE_GOVERNANCE
function* deleteGovernanceSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { governanceId } = payload
  const requestURL = `${FORM_BACK_URL}/governance/${governanceId}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getGovernanceAction())
      }
    }
  } catch (err) {
    console.error("[route] => /governance/:governanceId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//**********************************************************************************************
//******************************* SAGA Document Sollicité **************************************
//**********************************************************************************************
//GET_DOCUMENT_SOLLICITE
function* getAllDocumentSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/documentsForDocsManagement`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getDocumentsSuccessAction(response))
      }
    }
  } catch (err) {
    console.error("[route] => /documents => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* getAllDocumentsWaitingValidation({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/documentsWaitingForValidation`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getDocumentsWaitValidationSuccessAction(response))
      }
    }
  } catch (err) {
    console.error("[route] => /documents => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

//GET_DOCUMENT_SOLLICITE BY CONTROL ID
function* getDocumentsByControlIdSaga({ payload }) {
  const { controlId } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `documents/${controlId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getDocumentsByControlIdSuccessAction(response))
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

// PATCH DOCUMENT SOLLICITE
function* patchDocumentSolliciteSaga({ payload }) {
  const { newFile, idDocumentToPatch, controlId } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `documents/${idDocumentToPatch}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    // 1) post file into ETL
    const responsePostFile = yield call(postFileToS3, newFile)
    if (responseTypeIsError(responsePostFile))
      yield call(manageErrorGenerator, { response: responsePostFile, showMessageToUser: true })
    else {
      // 2) patch requested document in database
      const contentToPatch = {
        fileName: responsePostFile?.body?.name,
        status: "added",
      }
      const responsePatchRequestedDoc = yield call(
        request,
        requestURL,
        patchCors(contentToPatch, specificHeaders)
      )
      if (responseTypeIsError(responsePatchRequestedDoc))
        yield call(manageErrorGenerator, { response, showMessageToUser: true })
      else yield put(getControlAndTemplateByIdAction({ controlId }))
    }
  } catch (err) {
    console.error(`[route] => ${endPath} => ERROR PATCH DOC SOLLICITE=> `, err)
    yield put(setErrorMessage(err))
  }
}

// GET DOCUMENTS ASSOCIATE RESPONSE CONTROL
export function* getDocumentsAssociateResponse({ payload }) {
  const token = yield select(selectCurrentToken)
  const { responseId } = payload

  if (!responseId) {
    yield put(getDocumentsAssociateResponseSuccessAction([]))
  } else {
    try {
      const response = yield call(
        request,
        `${config?.FORM_BACK_URL}/documentsByResponse/${responseId}`,
        getCors({ token })
      )

      if (responseTypeIsError(response)) {
        yield call(manageErrorGenerator, { response, showMessageToUser: true })
      } else {
        yield put(getDocumentsAssociateResponseSuccessAction(response.body))
      }
    } catch (err) {
      console.error(
        `[route] => /documentsByResponse/${responseId} => GET DOC ASSOCIATE RESPONSE CONTROL => `,
        err
      )
      yield put(setErrorMessage(err))
    }
  }
}

/**
 * POST DOCUMENT ASSOCIATE TO RESPONSE CONTROL FOR SWAN
 * Une V2 existe juste en dessous pour le planning V2
 */
function* postDocumentAssociateResponseMappingRisk({ payload }) {
  const { newFile, document, responseId, templateId, userName } = payload
  const { id, associationType, format, ...documentToSend } = document

  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `associateDocumentToResponse/${responseId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const responsePostFile = yield call(postFileToS3, newFile)
    if (responseTypeIsError(responsePostFile))
      yield call(manageErrorGenerator, { response: responsePostFile, showMessageToUser: true })
    else {
      const newDocument = {
        ...documentToSend,
        creatorName: userName,
        fileName: responsePostFile?.body?.name,
        documentRequestId: id,
      }
      const responseFromBack = yield call(
        request,
        requestURL,
        postCors({ newDocument, templateId }, specificHeaders)
      )
      if (responseTypeIsError(responseFromBack))
        yield call(manageErrorGenerator, { response: responseFromBack, showMessageToUser: true })
      else {
        yield call(manageSuccessGenerator, { response: responseFromBack, showMessageToUser: false })
        yield put(getDocumentsAssociateResponseAction({ responseId }))
      }
    }
  } catch (error) {
    console.error(`[route] => ${endPath} `, err)
    yield put(setErrorMessage(err))
  }
}

/**
 * J'ai créé une V2 parce que le formats des documents envoyé dans le payload est différent
 * note: l'id est différent
 */
function* postDocumentAssociateResponseMappingRiskV2({ payload }) {
  const { newFile, document, responseId, templateId, userName } = payload
  /**
   * Destructuration et retrait des keys inutile au post document
   * note: si on envoi "_id", "_etag", "controlId", "isMandatory" ou "requestCreationDate" la validation schema fail
   */
  const {
    associationType,
    format,
    _id,
    _etag,
    controlId,
    isMandatory,
    requestCreationDate,
    ...documentToSend
  } = document

  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `associateDocumentToResponse/${responseId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const responsePostFile = yield call(postFileToS3, newFile)

    if (responseTypeIsError(responsePostFile)) {
      yield call(manageErrorGenerator, { response: responsePostFile, showMessageToUser: true })
    } else {
      const newDocument = {
        ...documentToSend,
        creatorName: userName,
        fileName: responsePostFile?.body?.name,
        documentRequestId: _id?.$oid,
      }

      const responseFromBack = yield call(
        request,
        requestURL,
        postCors({ newDocument, templateId }, specificHeaders)
      )

      if (responseTypeIsError(responseFromBack)) {
        yield call(manageErrorGenerator, { response: responseFromBack, showMessageToUser: true })
      } else {
        yield call(manageSuccessGenerator, { response: responseFromBack, showMessageToUser: false })
        yield put(getDocumentsAssociateResponseAction({ responseId }))
      }
    }
  } catch (error) {
    console.error(`[route] => ${endPath} `, err)
    yield put(setErrorMessage(err))
  }
}
// POST DOCUMENTS ASSOCIATE TO RESPONSES CONTROL FOR 99 ADVISORY
function* postDocumentAssociateResponse({ payload }) {
  const { files, responseId, templateId } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `associateFreeDocumentsToResponse/${responseId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`
  const bodyToSend = {
    documents: [],
    templateId: templateId,
  }

  try {
    // 1) we loop over the files to add them to the ETL
    for (let file of files) {
      const responsePostFile = yield call(postFileToS3, file)
      if (responseTypeIsError(responsePostFile))
        yield call(manageErrorGenerator, { response: responsePostFile, showMessageToUser: true })
      else {
        const fileName = responsePostFile?.body?.name
        bodyToSend.documents.push({ fileName: fileName })
      }
    }

    // 2) we compare length of files and ETLFiles and if its equal we save fileNames in back
    if (files.length === bodyToSend.documents.length) {
      const responseFromBack = yield call(
        request,
        requestURL,
        postCors(bodyToSend, specificHeaders)
      )
      if (responseTypeIsError(responseFromBack))
        yield call(manageErrorGenerator, { response: responseFromBack, showMessageToUser: true })
      else yield put(getDocumentsAssociateResponseAction({ responseId }))
    }
  } catch (err) {
    console.error(`[route] => ${endPath} => ERROR POST DOC ASSOCIATE CONTROL => `, err)
    yield put(setErrorMessage(err))
  }
}

function* deleteDocumentAssociateById({ payload }) {
  const { responseId, documentAssociateId, fileNameToDelete } = payload
  const token = yield select(selectCurrentToken)
  
  const specificHeaders = { token: token }

  const { API_URL, FORM_BACK_URL } = config
  const endPath = `/v1/files/${fileNameToDelete}`
  const requestURL_ETL = `${API_URL}${endPath}`

  try {
    // 1. We remove file from ETL
    const responseFromETL = yield call(request, requestURL_ETL, deleteCors(specificHeaders))
    if (responseTypeIsError(responseFromETL))
      yield call(manageErrorGenerator, { response: responseFromETL, showMessageToUser: true })
    else {
      //2. If success we remove document associate in MONGO
      const endPath = `/deleteDocumentAssociateToResponse/${documentAssociateId}`
      const requestURL_FROM = `${FORM_BACK_URL}${endPath}`
      const responseFromBack = yield call(request, requestURL_FROM, deleteCors(specificHeaders))
      if (responseTypeIsError(responseFromBack))
        yield call(manageErrorGenerator, { response: responseFromBack, showMessageToUser: true })
      else yield put(getDocumentsAssociateResponseAction({ responseId }))
    }
  } catch (error) {
    console.error(`[route] => ${endPath} => ERROR DELETE DOCUMENT ASSOCIATE BY ID => `, err)
    yield put(setErrorMessage(err))
  }
}

function* deleteDocumentSolliciteSaga({ payload }) {
  const { idDocumentToPatch, fileNameToDelete, controlId } = payload

  const token = yield select(selectCurrentToken)
  
  const specificHeaders = { token: token }

  const { API_URL, FORM_BACK_URL } = config
  const endPath = `/v1/files/${fileNameToDelete}`
  const requestURL_ETL = `${API_URL}${endPath}`

  try {
    // WE REMOVE FILE FROM ETL
    const response = yield call(request, requestURL_ETL, deleteCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      // If success delete into ETL we patch documentSollicite
      const fileName = response.body?.name
      const contentToPatch = {
        fileName: "",
        status: "waiting",
      }

      const endPath = `/documents/${idDocumentToPatch}`
      const requestURL_PATCH_DOC = `${FORM_BACK_URL}${endPath}`
      const responsePatchDoc = yield call(
        request,
        requestURL_PATCH_DOC,
        patchCors(contentToPatch, specificHeaders)
      )
      if (responseTypeIsError(responsePatchDoc))
        yield call(manageErrorGenerator, { responsePatchDoc, showMessageToUser: true })
      else {
        if (responseTypeIsSuccess(response))
          yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getControlAndTemplateByIdAction({ controlId }))
      }
    }
  } catch (err) {
    console.error(`[route] => ${endPath} => ERROR DELETE DOC SOLLICITE=> `, err)
    yield put(setErrorMessage(err))
  }
}

// we confirm documents send to the validation manager
function* confirmDocumentsAddedSaga({ payload }) {
  const { controlId } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `/confirmDocumentsAddedByClient/${controlId}`
  const requestURL = `${FORM_BACK_URL}${endPath}`

  try {
    const response = yield call(request, requestURL, patchCors({}, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getControlAndTemplateByIdAction({ controlId }))
    }
  } catch (err) {
    console.error(`[route] => ${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

// saga for validate requested document added by client
function* validateRequestedDocument({ payload }) {
  const { documentId, controlId } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `/managerValidDocument/${documentId}/${controlId}`
  const requestURL = `${FORM_BACK_URL}${endPath}`

  try {
    const response = yield call(request, requestURL, patchCors({}, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getDocumentsWaitValidationAction())
    }
  } catch (err) {
    console.error(`[route] => ${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

// saga for reject requested document added by client
function* rejectRequestedDocument({ payload }) {
  const { documentId, controlId } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `/managerRejectDocument/${documentId}/${controlId}`
  const requestURL = `${FORM_BACK_URL}${endPath}`

  try {
    const response = yield call(request, requestURL, patchCors({}, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getDocumentsWaitValidationAction())
    }
  } catch (err) {
    console.error(`[route] => ${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}
//**********************************************************************************************
//************************************ SAGA Historique *****************************************
//**********************************************************************************************
//GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS_SUCCESS
function* getAllControlsArchivedSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/archivedControls`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getControlPlanWithControlsArchivedSuccessAction(response))
    }
  } catch (err) {
    console.error("[route] => /archivedControls => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* documentManagementSaga() {
  yield takeEvery(GET_ACTUALITY, getAllActualitySaga)
  yield takeEvery(GET_ACTUALITY_BY_ID, getActualityByIdSaga)
  yield takeEvery(POST_ACTUALITY, postActualitySaga)
  yield takeEvery(POST_FILE_ACTUALITY, postFilesActualitySaga)
  yield takeEvery(PATCH_ACTUALITY, patchActualitySaga)
  yield takeEvery(ARCHIVED_ACTUALITY, patchArchivedActualitySaga)
  yield takeEvery(DELETE_ACTUALITY, deleteActualitySaga)
  yield takeEvery(GET_GOVERNANCE, getAllGovernanceSaga)
  yield takeEvery(GET_GOVERNANCE_BY_ID, getGovernanceByIdSaga)
  yield takeEvery(POST_GOVERNANCE, postGovernanceSaga)
  yield takeEvery(PATCH_GOVERNANCE, patchGovernanceSaga)
  yield takeEvery(DELETE_GOVERNANCE, deleteGovernanceSaga)
  yield takeEvery(GET_DOCUMENT_SOLLICITE, getAllDocumentSaga)
  yield takeEvery(GET_DOCUMENTS_WAIT_VALIDATION, getAllDocumentsWaitingValidation)
  yield takeEvery(GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS, getAllControlsArchivedSaga)
  yield takeEvery(GET_DOCUMENTS_BY_CONTROL_ID, getDocumentsByControlIdSaga)
  yield takeEvery(PATCH_DOCUMENT_SOLLICITE, patchDocumentSolliciteSaga)
  yield takeEvery(DELETE_DOCUMENT_SOLLICITE, deleteDocumentSolliciteSaga)
  yield takeEvery(CONFIRM_DOCUMENTS_ADDED_BY_CLIENT, confirmDocumentsAddedSaga)
  yield takeEvery(VALIDATE_DOCUMENT_SOLLICITE, validateRequestedDocument)
  yield takeEvery(REJECT_DOCUMENT_SOLLICITE, rejectRequestedDocument)
  yield takeEvery(GET_DOCUMENTS_ASSOCIATE_RESPONSE, getDocumentsAssociateResponse)
  yield takeEvery(POST_DOCUMENTS_ASSOCIATE_RESPONSE, postDocumentAssociateResponse)
  yield takeEvery(
    POST_DOCUMENT_ASSOCIATE_RESPONSE_MAPPING_RISK,
    postDocumentAssociateResponseMappingRisk
  )
  yield takeEvery(
    POST_DOCUMENT_ASSOCIATE_RESPONSE_MAPPING_RISK_V2,
    postDocumentAssociateResponseMappingRiskV2
  )
  yield takeEvery(DELETE_DOCUMENT_ASSOCIATE_BY_ID, deleteDocumentAssociateById)
}

export default documentManagementSaga
